import React, { useEffect, useState } from 'react';
import { Col, Container, Pagination, Row } from 'react-bootstrap';
import { useParams, useSearchParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import Meta from '../Meta/Meta';
import CategoryCard from './CategoryCard';
import HorizontalAd from '../Ads/HorizontalAd';
import './Category.css';

const Category = () => {

    if (!Cookies.get('lg')) {
        Cookies.set('lg', 'en');
    }

  const { categoryname, searchdata } = useParams();

const invalidSlugs = ["hi", "tl"];

const cleanCategory = invalidSlugs.includes(categoryname)
    ? null
    : categoryname;
    const [searchParams, setSearchParams] = useSearchParams();

    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState({});

    // ✅ read page from URL
    const page = searchParams.get("page") || "1";

  const fetchData = async (pagenumber = "1") => {
    try {
        setIsLoading(true);
        const lang = Cookies.get('lg') || 'en';

        let url;
        if (searchdata) {
            url = `/api/${lang}/search?name=${searchdata}&page=${pagenumber}`;
        } else if (categoryname) {
            url = `/api/${lang}/categorypage?name=${categoryname}&page=${pagenumber}`;
        } else {
            setIsLoading(false);
            return;
        }

        const response = await fetch(url, { method: "POST" });
        const result = await response.json();

        if (result.status === 1) {
            setData(result.data || {});
        } else {
            setData({});
        }
    } catch (err) {
        console.error("Category API Error:", err);
        setData({});
    } finally {
        setIsLoading(false);
    }
};

    // ✅ refetch when page OR category changes
    useEffect(() => {
        setIsLoading(true);
        fetchData(page);
    }, [categoryname, searchdata, page]);

    if (isLoading) {
        return (
            <div className="d-flex align-items-center justify-content-center vh-100">
                <p>Loading...</p>
            </div>
        );
    }

    const { metadata, categorydata = [], pagination, pagetitle, ads = [] } = data;

    const handlePagination = (pnumber) => {
        setSearchParams({ page: pnumber }); // ✅ URL changes
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <>
            <Meta metadata={metadata} />

            <section className='category'>
                <Container>
                    <Row>
                        <div className='whitetitle'>
                            <h1>{pagetitle || "Category"}</h1>
                        </div>
                    </Row>

                    {categorydata.length > 0 ? (
                        categorydata.map((row, index) => (
                            <React.Fragment key={index}>
                                <Row>
                                    {row.map((card, i) => (
                                        <CategoryCard data={card} key={i} />
                                    ))}
                                </Row>

                                {ads[index] && <HorizontalAd {...ads[index]} />}
                            </React.Fragment>
                        ))
                    ) : (
                        <div className='d-flex justify-content-center vh-100'>
                            <p>No Data Found</p>
                        </div>
                    )}

                    {/* Pagination */}
                    {pagination && (
                        <Row>
                            <Col className='d-flex justify-content-center pg'>
                                <Pagination size="sm">
                                    {pagination.paginationurls.map((item, i) => {
                                    const key = Object.keys(item)[0];
                                    const value = item[key];

                                    return (
                                        <Pagination.Item
                                            key={i}
                                            active={pagination.paginationnumber === value}
                                            onClick={() => handlePagination(value)}
                                        >
                                            {key}
                                        </Pagination.Item>
                                    );
                                })}
                                </Pagination>
                            </Col>
                        </Row>
                    )}
                </Container>
            </section>
        </>
    );
};

export default Category;